import { DashboardPage } from "@/features/dashboard/pages";

const Dashboard = () => {
  return <DashboardPage />;
};

export default Dashboard;
